import { Camera, Mesh, PlaneGeometry, RawShaderMaterial, Scene } from "three";

export class FboBase {
    constructor(props) {
        var t;
        this.props = props;
        this.uniforms = (t = this.props.material) == null ? void 0 : t.uniforms;
    }
    init() {
        this.scene = new Scene();
        this.camera = new Camera();
        if(this.uniforms){
            this.material = new RawShaderMaterial(this.props.material);
            this.geometry = new PlaneGeometry(2,2);
            this.plane = new Mesh(this.geometry,this.material);
            this.scene.add(this.plane);
        }
    }
    update() {
        this.props.common.renderer.setRenderTarget(this.props.output);
        this.props.common.renderer.render(this.scene, this.camera);
        this.props.common.renderer.setRenderTarget(null);
    }
}